// extracted by mini-css-extract-plugin
module.exports = {"images":"styles_images__2A_Ra","pulse":"styles_pulse__40Zy1","jump":"styles_jump__SvTp1","wiggle":"styles_wiggle__wK463"};